import card40 from './40.jpg';
import card41 from './41.jpg';
import card42 from './42.jpg';
import card43 from './43.jpg';
import card44 from './44.jpg';
import card45 from './45.jpg';
import card46 from './46.jpg';
import card47 from './47.jpg';
import card48 from './48.jpg';
import card49 from './49.jpg';
import card50 from './50.jpg';
import card51 from './51.jpg';
import card52 from './52.jpg';

const cards_data3 = [
    {
        image:card40,
        
    },
    {
        image:card41,
       
    },
    {
        image:card42,
        
    },
    {
        image:card43,
        
    },
    {
        image:card44,
        
    },
    {
        image:card45,
        
    },
    {
        image:card46,
        
    },
    {
        image:card47,
       
    },
    {
        image:card48,
        
    },
    {
        image:card49,
        
    },
    {
        image:card50,
        
    },
    {
        image:card51,
       
    },
    {
        image:card52,
        
    }
]
export default cards_data3;